<template>
  <div class="wrapper">
    <mobile-header />
    <div class="main">
      <slot name="title"></slot>
      <slot name="content"></slot>
    </div>
    <mobile-footer />
  </div>
</template>

<script>
import MobileHeader from '@/views/mobile/components/header/Index.vue'
import MobileFooter from '@/views/mobile/components/footer/Index.vue'

export default {
  name: 'PcList',
  components: {
    MobileHeader,
    MobileFooter,
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
}

.main {
  position: relative;
  padding: 13.333333vw 0 0;
  width: 100%;
  min-height: calc(100vh - 27.733333vw);
  background: #fffcf1;
  background-repeat: no-repeat;
  background-image: url('~@/assets/img/mobile/page_bg.png');
  background-size: 100%;
  background-position: top;
}
</style>